import * as CONSTANTS from '../constants/constants';

export const uploadPost = newPost => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  dispatch({ type: CONSTANTS.SET_LOADING_POST });
  const firebase = getFirebase();
  const firestore = getFirestore();
  const postData = {
    title: newPost.title,
    author: newPost.author.fullName,
    authorId: newPost.author.uid,
    content: newPost.content,
    readTime: newPost.readTime,
    slug: newPost.title.toLowerCase().replace(/[' '|&|,|(|)|&|@|!|%|^|+|=]/gi, "-"),
    created: Date.now(),
    // tags: newPost.tags,
    image: newPost.fileList[0].thumbUrl,
    postcategory: newPost.postCat,
    asDraft: newPost.asDraft,
    edited: null,
    likers: [],
    likes: 0,
    commentsNo: 0
  }
  const posts = [];
  const postRef = firestore.collection(CONSTANTS.POST);
  postRef.get().then((querySnapshot) => {
    querySnapshot.forEach((post) => {
      posts.push(Object.assign(post.data(), { id: post.id }));
    });
    var checkPost = []
    checkPost = posts.filter((post) => {
      return post.slug === postData.slug
    })
    if (!checkPost.length) {
      postRef.add(postData)
        .then((docRef) => {
          // var postId = docRef.id
          // const userRef = firestore.collection(CONSTANTS.USERS).doc(postData.authorId);
          // userRef.get().then((snapshot) => {
          //   const user = Object.assign(snapshot.data(), { id: snapshot.id });
          //   var authorPosts = user.posts
          //   authorPosts.push({ postId })
          //   userRef.update({
          //     posts: authorPosts
          //   }).then(() => {
          //     console.log('went well')
          //   })
          //     .catch((error) => {
          //       console.log(error)
          //     })
          // })
          dispatch({ type: CONSTANTS.UPLOAD_POST_SUCCESS });
          dispatch({ type: CONSTANTS.UPLOAD_POST_RESET_MSGS })
        })
        .catch((err) => {
          console.log(err)
        })
    } else {
      dispatch({ type: CONSTANTS.UPLOAD_POST_ERROR })
      dispatch({ type: CONSTANTS.UPLOAD_POST_RESET_MSGS })
    }
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.log('error', e);
  });
}

export const editPost = newPost => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  dispatch({ type: CONSTANTS.SET_LOADING_POST });
  const firebase = getFirebase();
  const firestore = getFirestore();
  const postData = {
    title: newPost.title,
    author: newPost.author.fullName,
    authorId: newPost.author.uid,
    content: newPost.content,
    readTime: newPost.readTime,
    slug: newPost.title.toLowerCase().replace(/[' '|&|,|(|)|&|@|!|%|^|+|=]/gi, "-"),
    edited: Date.now(),
    // tags: newPost.tags,
    image: newPost.image,
    postcategory: newPost.postCat,
    asDraft: newPost.asDraft,
    created: newPost.created,
    likers: newPost.likers,
    likes: newPost.likes,
    commentsNo: newPost.commentsNo
  }
  const posts = [];
  const postRef = firestore.collection(CONSTANTS.POST);
  postRef.get().then((querySnapshot) => {
    querySnapshot.forEach((post) => {
      posts.push(Object.assign(post.data(), { id: post.id }));
    });
    var checkPost = []
    checkPost = posts.filter((post) => {
      return post.slug === postData.slug
    })
    if (!checkPost.length) {
      postRef.doc(newPost.id).set(postData).then(() => {
        dispatch({ type: CONSTANTS.EDIT_POST_SUCCESS });
        dispatch({ type: CONSTANTS.UPLOAD_POST_RESET_MSGS })
      })
    } else {
      if(checkPost[0].id === newPost.id) {
        postRef.doc(newPost.id).set(postData).then(() => {
          dispatch({ type: CONSTANTS.EDIT_POST_SUCCESS });
          dispatch({ type: CONSTANTS.UPLOAD_POST_RESET_MSGS })
        })
      } else {
        dispatch({ type: CONSTANTS.EDIT_POST_ERROR });
        dispatch({ type: CONSTANTS.UPLOAD_POST_RESET_MSGS })
      }
    }
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.log('error', e);
  });
}

export const addVote = postData => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  dispatch({ type: CONSTANTS.SET_LOADING_POST });
  const firebase = getFirebase();
  const firestore = getFirestore();
  const postRef = firestore.collection(CONSTANTS.POST).doc(postData.postId);
  postRef.update({
    likes: firebase.firestore.FieldValue.increment(1),
    likers: postData.likers
  }).then((data) => {
    // console.log('done')
  }).catch((err) => {
    console.log('error', err)
  })
}

export const uploadPostCat = newPostCat => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  dispatch({ type: CONSTANTS.SET_LOADING_POSTCAT });
  const firebase = getFirebase();
  const firestore = getFirestore();
  const postCatData = {
    name: newPostCat.name,
    author: newPostCat.author.fullName,
    authorId: newPostCat.author.uid,
    slug: newPostCat.name.toLowerCase(),
    desc: newPostCat.desc,
    created: Date.now(),
    edited: null
  }
  const postCats = [];
  const postCatRef = firestore.collection(CONSTANTS.POSTCAT);
  postCatRef.get().then((querySnapshot) => {
    querySnapshot.forEach((postcat) => {
      postCats.push(Object.assign(postcat.data(), { id: postcat.id }));
    });
    var checkPostCat = []
    checkPostCat = postCats.filter((postcat) => {
      return postcat.slug === postCatData.slug
    })
    if (!checkPostCat.length) {
      postCatRef.add(postCatData)
        .then((docRef) => {
          // var postCatId = docRef.id
          // const userRef = firestore.collection(CONSTANTS.USERS).doc(postCatData.authorId);
          // userRef.get().then((snapshot) => {
          //   const user = Object.assign(snapshot.data(), { id: snapshot.id });
          //   var authorCats = user.postcategories
          //   authorCats.push({ postCatId })
          //   userRef.update({
          //     postcategories: authorCats
          //   }).then(() => {
          //     console.log('went well')
          //   })
          //     .catch((error) => {
          //       console.log(error)
          //     })
          // })
          dispatch({ type: CONSTANTS.UPLOAD_POSTCAT_SUCCESS });
          dispatch({ type: CONSTANTS.UPLOAD_POSTCAT_RESET_MSGS })
        })
        .catch((err) => {
          console.log(err)
        })
    } else {
      dispatch({ type: CONSTANTS.UPLOAD_POSTCAT_ERROR })
      dispatch({ type: CONSTANTS.UPLOAD_POSTCAT_RESET_MSGS })
    }
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.log('error', e);
  });
}

export const deletePost = (postId) =>(
  dispatch,
  getState, 
  {getFirestore}) => {
  const firestore = getFirestore();
    firestore.collection("posts").doc(postId).delete()
    .then(()=>{
      console.log('deleting...')
      dispatch({ type: CONSTANTS.DELETE_POST_SUCCESS  })
      dispatch({ type: CONSTANTS.DELETE_POST_RESET_MSGS })
  })
  .catch((err)=> {
    console.log('error', err)
  })   
}

export const editPostCat = (newPostCat) => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  dispatch({ type: CONSTANTS.SET_LOADING_POSTCAT });
  const firebase = getFirebase();
  const firestore = getFirestore();
  const postCatData = {
    name: newPostCat.name,
    author: newPostCat.author.fullName,
    authorId: newPostCat.author.uid,
    slug: newPostCat.name.toLowerCase(),
    desc: newPostCat.desc,
    edited: Date.now(),
    created: newPostCat.created
  }
  // console.log(postCatData)
  const postCats = [];
  const postCatRef = firestore.collection(CONSTANTS.POSTCAT);
  postCatRef.get().then((querySnapshot) => {
    querySnapshot.forEach((postcat) => {
      postCats.push(Object.assign(postcat.data(), { id: postcat.id }));
    });
    var checkPostCat = []
    checkPostCat = postCats.filter((postcat) => {
      return postcat.slug === postCatData.slug
    })
    if (!checkPostCat.length) {
      postCatRef.doc(newPostCat.id).set(postCatData).then(() => {
        dispatch({ type: CONSTANTS.EDIT_POSTCAT_SUCCESS });
        dispatch({ type: CONSTANTS.UPLOAD_POSTCAT_RESET_MSGS })
      })
    } else {
      if(checkPostCat[0].id === newPostCat.id) {
        postCatRef.doc(newPostCat.id).set(postCatData).then(() => {
          dispatch({ type: CONSTANTS.EDIT_POSTCAT_SUCCESS });
          dispatch({ type: CONSTANTS.UPLOAD_POSTCAT_RESET_MSGS })
        })
      } else {
        dispatch({ type: CONSTANTS.EDIT_POSTCAT_ERROR });
        dispatch({ type: CONSTANTS.UPLOAD_POSTCAT_RESET_MSGS })
      }
    }
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.log('error', e);
  });
}

export const sendComment = commentDetails => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  // dispatch({ type: CONSTANTS.SET_LOADING_POST });
  const firebase = getFirebase();
  const firestore = getFirestore();
  const postRef = firestore.collection(CONSTANTS.POST).doc(commentDetails.postId);
  const commentRef = postRef.collection('comments')
  commentRef.add({
    likes: 0,
    content: commentDetails.maincomment,
    commenterId: commentDetails.userId,
    commenterName: commentDetails.fullName,
    created: Date.now(),
    likers: []
  })
  .then((data) => {
    postRef.update({
      commentsNo: firebase.firestore.FieldValue.increment(1)
    })
    dispatch({ type: CONSTANTS.REFRESH_COMMENTS });
  }).catch((err) => {
    console.log('error', err)
  })
}

export const sendReplyComment = replyCommentDetails => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  // dispatch({ type: CONSTANTS.SET_LOADING_POST });
  const firebase = getFirebase();
  const firestore = getFirestore();
  const postRef = firestore.collection(CONSTANTS.POST).doc(replyCommentDetails.postId);
  const commentRef = postRef.collection('comments').doc(replyCommentDetails.commentId);
  const replyCommentRef = commentRef.collection('subcomments')
  replyCommentRef.add({
    likes: 0,
    content: replyCommentDetails.maincomment,
    commenterId: replyCommentDetails.userId,
    commenterName: replyCommentDetails.fullName,
    created: Date.now(),
    likers: []
  })
  .then((data) => {
    dispatch({ type: CONSTANTS.REFRESH_COMMENTS });
  }).catch((err) => {
    console.log('error', err)
  })
}

export const likeComment = commentDetails => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  // dispatch({ type: CONSTANTS.SET_LOADING_POST });
  const firebase = getFirebase();
  const firestore = getFirestore();
  const postRef = firestore.collection(CONSTANTS.POST).doc(commentDetails.postId);
  const commentRef = postRef.collection('comments').doc(commentDetails.commentId)
  commentRef.update({
    likes: firebase.firestore.FieldValue.increment(1),
    likers: commentDetails.likers
  }).then((data) => {
    dispatch({ type: CONSTANTS.REFRESH_COMMENTS });
  }).catch((err) => {
    console.log('error', err)
  })
}

export const unLikeComment = commentDetails => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  // dispatch({ type: CONSTANTS.SET_LOADING_POST });
  const firebase = getFirebase();
  const firestore = getFirestore();
  const postRef = firestore.collection(CONSTANTS.POST).doc(commentDetails.postId);
  const commentRef = postRef.collection('comments').doc(commentDetails.commentId)
  commentRef.update({
    likes: firebase.firestore.FieldValue.increment(-1),
    likers: commentDetails.likers
  }).then((data) => {
    dispatch({ type: CONSTANTS.REFRESH_COMMENTS });
  }).catch((err) => {
    console.log('error', err)
  })
}

export const likeSubComment = commentDetails => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  // dispatch({ type: CONSTANTS.SET_LOADING_POST });
  const firebase = getFirebase();
  const firestore = getFirestore();
  const postRef = firestore.collection(CONSTANTS.POST).doc(commentDetails.postId);
  const commentRef = postRef.collection('comments').doc(commentDetails.commentId)
  const subcommentRef = commentRef.collection('subcomments').doc(commentDetails.subcommentId)
  subcommentRef.update({
    likes: firebase.firestore.FieldValue.increment(1),
    likers: commentDetails.likers
  }).then((data) => {
    dispatch({ type: CONSTANTS.REFRESH_COMMENTS });
  }).catch((err) => {
    console.log('error', err)
  })
}

export const unLikeSubComment = commentDetails => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  // dispatch({ type: CONSTANTS.SET_LOADING_POST });
  const firebase = getFirebase();
  const firestore = getFirestore();
  const postRef = firestore.collection(CONSTANTS.POST).doc(commentDetails.postId);
  const commentRef = postRef.collection('comments').doc(commentDetails.commentId)
  const subcommentRef = commentRef.collection('subcomments').doc(commentDetails.subcommentId)
  subcommentRef.update({
    likes: firebase.firestore.FieldValue.increment(-1),
    likers: commentDetails.likers
  }).then((data) => {
    dispatch({ type: CONSTANTS.REFRESH_COMMENTS });
  }).catch((err) => {
    console.log('error', err)
  })
}